/* ZAVANI — Mobile uniquement : points de navigation sous les carrousels
   (formats, en cuisine) et carte 10 gousses centrée au départ. Inactif sur ordinateur. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');

  function setup(grid, startIndex) {
    if (!grid || grid.__zvDots) return;
    var cards = Array.prototype.filter.call(grid.children, function (c) { return c.nodeType === 1; });
    if (cards.length < 2) return;
    grid.__zvDots = true;

    var dots = document.createElement('div');
    dots.className = 'zv-dots';
    dots.setAttribute('aria-hidden', 'true');
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.tabIndex = -1;
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b);
    });
    grid.insertAdjacentElement('afterend', dots);

    function go(i, instant) {
      var c = cards[i];
      var left = c.offsetLeft - (grid.clientWidth - c.clientWidth) / 2;
      grid.scrollTo({ left: Math.max(0, left), behavior: instant ? 'auto' : 'smooth' });
    }
    function update() {
      var mid = grid.scrollLeft + grid.clientWidth / 2, best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid);
        if (d < bd) { bd = d; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (b, i) { b.classList.toggle('is-active', i === best); });
    }
    var raf = null;
    grid.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });

    if (startIndex) { setTimeout(function () { go(startIndex, true); update(); }, 60); }
    else { update(); }
  }

  function init() {
    if (!mq.matches) return;
    setup(document.querySelector('.zv-formats__grid'), 1);
    setup(document.querySelector('.zv-usages__grid'), 0);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
